import { OptionProps } from '@match/react-component-library';
import { useCurrentUser, useSiteData } from 'modules/hooks';

interface UseBuildContactUsSC3RequestProps {
  categorySelection: string | ((selection?: OptionProps<{}> | undefined) => void);
  deviceSelection: string | ((selection?: OptionProps<{}> | undefined) => void);
  emailAddress: string | undefined;
  nameInput: string | undefined;
  questionText: string;
}

const useBuildContactUsSC8Request = ({
  categorySelection,
  deviceSelection,
  emailAddress,
  nameInput,
  questionText,
}: UseBuildContactUsSC3RequestProps) => {
  const currentUser = useCurrentUser();
  const siteData = useSiteData();
  const userName = siteData.handle ? siteData.handle : nameInput;
  const userId = currentUser.userId !== '0' ? currentUser.userId : 'not logged in';
  const isPtBr = siteData.cultureCode === 'pt-BR';
  const categoryId = isPtBr ? 6637540077716 : 6637568523028;

  const requestBody = {
    request: {
      requester: {
        name: userName,
        email: emailAddress,
      },
      brand_id: 6656056211860,
      organization_id: 6656056211860,
      requester_id: userName,
      subject: categorySelection,
      comment: {
        body: questionText,
      },
      tags: ['formulario_faq'],
      custom_fields: [
        { id: categoryId, value: categorySelection },
        { id: 6638393085076, value: deviceSelection },
        { id: 360036453213, value: userName },
        { id: 360036521914, value: userId },
      ],
    },
  };

  return { requestBody };
};

export default useBuildContactUsSC8Request;
